<template src="./Filter.html"></template>
<style src="./Filter.css"></style>

<script>
import DataDetail from "@/components/VendaRapidaNFCe/DataDetail/DataDetail";

import store from "@/store";
import { api } from "@/services/index";
import {
  loadVendaRapidaNFCe,
  loadVendaRapidaNFCeDetail,
  loadVendaRapidaNFCeSituations,
  loadVendaRapidaNFCeRejections
} from "@/services/modules/vendaRapidaNFCe";

import * as GraficosService from "../../../providers/graficos.service";
import moment from "moment";
moment.locale("pt-BR");

export default {
  components: {
    "app-venda-rapida-nfce-data-detail": DataDetail
  },
  data() {
    var self = this;

    return {
      dateOne: null,
      dateTwo: null,
      selectedSituations: [],
      rejectionsHeaders: [
        {
          text: "Selecionado",
          value: "selected",
          sortable: false
        },
        {
          text: "Rejeição",
          value: "VENRNFCEREJEICAO"
        },
        {
          text: "Quantidade",
          value: "COUNT"
        }
      ],
      rejectionsPagination: { rowsPerPage: 25 },
      rejectionsRowsPerPageItems: [
        {
          text: "25",
          value: 25
        },
        {
          text: "50",
          value: 50
        },
        {
          text: "100",
          value: 100
        },
        {
          text: "300",
          value: 300
        },
        {
          text: "500",
          value: 500
        },
        {
          text: "Todos",
          value: -1
        }
      ],
      dataHeaders: [
        {
          text: "Nome",
          value: "CLINOME"
        },
        {
          text: "Quantidade de Rejeições",
          value: "COUNT"
        }
      ],
      dataPagination: { rowsPerPage: 25 },
      dataRowsPerPageItems: [
        {
          text: "25",
          value: 25
        },
        {
          text: "50",
          value: 50
        },
        {
          text: "100",
          value: 100
        },
        {
          text: "300",
          value: 300
        },
        {
          text: "500",
          value: 500
        },
        {
          text: "Todos",
          value: -1
        }
      ],
      chartOptions: {
        labels: [
          "Aberto",
          "Confirmado",
          "Cancelado",
          "Pendente de autorização"
        ],
        legend: {
          position: "left"
        },
        chart: {
          events: {
            dataPointSelection: function(event, chartContext, config) {
              self.selectSituation(event, chartContext, config);
            },
            legendClick: function(chartContext, seriesIndex, config) {
              config.dataPointIndex = seriesIndex;
              self.selectSituation(event, chartContext, config);
            }
          }
        },
        expandOnClick: true,
        colors: ["#2A5377", "#88C658", "#53856a"],
        responsive: [
          {
            breakpoint: 1370,
            options: {
              chart: {
                width: 400
              },
              legend: {
                position: "right"
              }
            }
          },
          {
            breakpoint: 500,
            options: {
              chart: {
                width: 400
              },
              legend: {
                position: "left"
              }
            }
          }
        ]
      }
    };
  },
  created() {
    loadVendaRapidaNFCeSituations({});
    loadVendaRapidaNFCeRejections({});
    loadVendaRapidaNFCe({});
  },
  methods: {
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = `${moment(dateOne).format("DD")} ${moment(
          dateOne
        ).format("MMMM")}`;
      }
      if (dateTwo) {
        formattedDates += ` até ${moment(dateTwo).format("DD")} ${moment(
          dateTwo
        ).format("MMMM")}`;
      }
      return formattedDates;
    },
    getDateFilter() {
      if (this.dateOne == "" && this.dateTwo == "") return {};

      let initialDate = null;
      let finalDate = null;
      if (this.dateOne != null && this.dateOne != "")
        initialDate = moment(this.dateOne).format("YYYY-MM-DD");
      if (this.dateTwo != null && this.dateTwo != "")
        finalDate = moment(this.dateTwo).format("YYYY-MM-DD");

      return {
        venDtEmissaoIni: initialDate,
        venDtEmissaoFim: finalDate
      };
    },
    getRejeicoesFilter() {
      let aVenRNFCeRejeicao = [];
      store.state.vendaRapidaNFCe.rejections.forEach(element => {
        if (element.selected == true) {
          if (element.VENRNFCEREJEICAO == "Não informado")
            aVenRNFCeRejeicao.push("");
          else aVenRNFCeRejeicao.push(element);
        }
      });

      return aVenRNFCeRejeicao;
    },
    applyDateFilter(_onlyData = false) {
      this.selectedSituations = [];

      const dateFilter = this.getDateFilter();

      loadVendaRapidaNFCeSituations(dateFilter);
      loadVendaRapidaNFCeRejections(dateFilter);
      loadVendaRapidaNFCe(dateFilter);
    },
    cancelDateFilter() {
      loadVendaRapidaNFCeSituations({});
      loadVendaRapidaNFCeRejections({});
      loadVendaRapidaNFCe({});
    },
    selectSituation(event, chartContext, config) {
      var index = Number(config.dataPointIndex);

      if (this.selectedSituations.length == 0)
        this.selectedSituations.push(index);
      else {
        if (event.shiftKey) {
          var exists = false;
          this.selectedSituations.forEach(element => {
            if (element == index) exists = true;
          });
          if (!exists) this.selectedSituations.push(index);
        } else {
          this.selectedSituations = [];
          this.selectedSituations.push(index);
        }
      }

      this.applyFilterData();
    },
    removeSituation(_situation) {
      const index = this.selectedSituations.indexOf(_situation);
      this.selectedSituations.splice(index, 1);

      this.applyFilterData();
    },
    venRNFCeSituacao(_venRNFCeSituacao) {
      switch (_venRNFCeSituacao) {
        case 0:
          return "Aberto";
        case 1:
          return "Confirmado";
        case 2:
          return "Cancelado";
        case 3:
          return "Pendente de autorização";
        default:
          return "Desconhecido";
      }
    },
    toggleRejections(_rejection) {
      store.dispatch("setVendaRapidaNFCeToggleRejections", _rejection);

      this.applyFilterData();
    },
    applyFilterData() {
      const aVenRNFCeRejeicao = this.getRejeicoesFilter();

      const dateFilter = this.getDateFilter();
      loadVendaRapidaNFCe({
        ...dateFilter,
        aVenRNFCeRejeicao,
        aVenRNFCeSituacao: this.selectedSituations
      });
    },
    dataOnClick(_data) {
      store.dispatch("setVendaRapidaNFCeDataExpanded", _data);
    },
    expandItem(_data, _cliCodigo) {
      _data.expanded = !_data.expanded;

      if (_data.expanded) {
        let loadDetails = true;
        store.state.vendaRapidaNFCe.dataDetail.forEach(detail => {
          if (detail.length > 0)
            if (detail[0].CLICODIGO == _cliCodigo) loadDetails = false;
        });

        if (loadDetails) {
          const dateFilter = this.getDateFilter();
          const aVenRNFCeRejeicao = this.getRejeicoesFilter();
          loadVendaRapidaNFCeDetail(_cliCodigo, {
            ...dateFilter,
            aVenRNFCeRejeicao,
            aVenRNFCeSituacao: this.selectedSituations
          });
        }
      }
    }
  },
  computed: {
    isXs() {
      return store.state.window.isXs;
    },
    data() {
      return store.state.vendaRapidaNFCe.data;
    },
    loadingData() {
      return store.state.vendaRapidaNFCe.loadingData;
    },
    situations() {
      return store.state.vendaRapidaNFCe.situations;
    },
    loadingSituations() {
      return store.state.vendaRapidaNFCe.loadingSituations;
    },
    rejections() {
      return store.state.vendaRapidaNFCe.rejections;
    },
    loadingRejections() {
      return store.state.vendaRapidaNFCe.loadingRejections;
    }
  }
};
</script>